// format-currency.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyService } from '../services/currency.service';
import { AuthService } from '../services/auth.service';

@Pipe({ name: 'formatCurrency', pure: false })
export class FormatCurrencyPipe implements PipeTransform {
  constructor(private currency: CurrencyService, private auth: AuthService) {}

  transform(value: number | string, codeOverride?: string): string {
    if (value === null || value === undefined || value === '') return '';

    const num = typeof value === 'string' ? Number(value) : value;
    if (Number.isNaN(num)) return '';

    const code = (codeOverride || this.currency.code || 'BRL').toUpperCase();
    const locale = this.currency.getLocaleFor(code);

    const digits = this.auth.hasFeatureFlagNewParam() ? 3 : 2;

    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: code,
      minimumFractionDigits: digits,
      maximumFractionDigits: digits,
    }).format(num);
  }
}
